
/* styles */
require("!!style-loader!css-loader!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-605d2ee2&scoped=true!sass-loader!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./menu-item.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./menu-item.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-605d2ee2!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./menu-item.vue"),
  /* scopeId */
  "data-v-605d2ee2",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/tofu-menu/src/menu-item.vue
// module id = 586
// module chunks = 0